import * as yup from 'yup';

/** サーバー側 cogevoStampImage.helper と同じ規約 */
export const COGEVO_STAMP_MONTH_PATTERN = /^\d{4}-(0[1-9]|1[0-2])$/;

export const formSchemaFn = (isActionEdit: boolean) =>
  yup.object().shape({
    isDefault: yup.boolean(),
    // 対象月は imageCode の一部なので作成時のみ入力する
    month: isActionEdit
      ? yup.string().nullable()
      : yup
          .string()
          .when('isDefault', ([isDefault], schema) =>
            isDefault
              ? schema.nullable()
              : schema
                  .trim()
                  .required('対象月は未入力です。')
                  .matches(
                    COGEVO_STAMP_MONTH_PATTERN,
                    '対象月は YYYY-MM 形式（例: 2026-09）で入力してください。',
                  ),
          ),
    url: yup.string().trim().required('イラスト画像は未設定です。'),
    sortOrder: yup
      .number()
      .typeError('並び順は数字で入力してください。')
      .integer('並び順は整数で入力してください。')
      .min(0, '並び順は0以上で入力してください。')
      .required('並び順は未入力です。'),
    isActive: yup.boolean(),
  });
